import * as React from 'react';
export default function FooterRow(props) {
  return /*#__PURE__*/React.createElement("tr", props);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/Footer/Row.js
// module id = 3720
// module chunks = 0